module.exports = __webpack_public_path__ + "ba.5f6a730942fb98060601.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ba.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ba.svg
// module chunks = styles